module.exports = __webpack_public_path__ + "static/12-50c1f9a54c9b5715db09a6c665eebbcd.jpg";